module.exports = __webpack_public_path__ + "static/brenda-06a5c325a908b98dcca14851bf6a79d6.jpg";